import { StyleSheet } from 'react-native';

const style = StyleSheet.create({
    chLogo: {
        position: 'absolute',
        top: 8,
        right: 8,
        height: 16,
    },
    gradient: {
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        opacity: 0.5,
    },
});

export default style;
